import {Component, DestroyRef, OnInit} from "@angular/core";
import {ViewportScroller} from "@angular/common";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {filter} from "rxjs";
import {hasStoredToken} from "../../core/services/session-token";
import {DiscordIconComponent} from "../shared/discord-icon/discord-icon.component";

@Component({
    selector: 'app-landing-layout',
    templateUrl: './landing-layout.component.html',
    styleUrls: ['./landing-layout.component.scss'],
    imports: [RouterLink, RouterLinkActive, RouterOutlet, DiscordIconComponent]
})
export class LandingLayoutComponent implements OnInit {

  isHome = false;
  menuOpen = false;
  userIsLoggedIn: boolean;
  currentYear: number = new Date().getFullYear();

  /** Room for the sticky header when the router scrolls to a #fragment (it ignores scroll-margin). */
  private static readonly ANCHOR_OFFSET_PX = 96;

  constructor(private router: Router, private destroyRef: DestroyRef, private viewportScroller: ViewportScroller) {
  }

  ngOnInit() {
    this.viewportScroller.setOffset([0, LandingLayoutComponent.ANCHOR_OFFSET_PX]);
    this.isHome = this.isHomeUrl(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => {
        this.isHome = this.isHomeUrl(event.urlAfterRedirects);
        this.menuOpen = false;
      });

    this.userIsLoggedIn = hasStoredToken();
  }

  private isHomeUrl(url: string): boolean {
    return url.split(/[?#]/)[0] === '/';
  }
}
